export default {
	about_the: 'Sobre o',
	company_agency: 'Cidade',
	document: 'CPF',
	gmin_number: 'Razão Social (Caso possua)',
	headquarter: 'Estado',
	place: 'Ranking',
	project_name: 'Electrolux Instala',
	regionals: 'Localização',
	register: 'CNPJ (Caso possua)',
	select_profile: 'Perfil',
	user: 'E-mail',
	welcome_to: 'Bem-vindo(a) ao',
	platform_meta_description:
		'Conteúdos gratuitos sobre refrigeração, eventos, novidades de mercado, atendimento técnico e benefícios exclusivos oferecidos pela Electrolux.',
	challenge_of_the_day: 'Desafie-se',
	can_you_answer_this_question: 'Responda e garanta o acesso exclusivo à página Parceiro Electrolux.',
	recall_and_test_your_knowledge_with_quick_questions: 'Responda e garanta o acesso exclusivo à página Parceiro Electrolux.',
	answer: 'Responder',
}
